<template>
  <BaseModalSmall @close="$emit('noClick')">
    <BaseHeading>{{ $t('new_import.warning') }}</BaseHeading>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('noClick')"
      >
        {{ $t('global.no') }}
      </BaseButton>
      <BaseButton @click="handleExit">{{ $t('global.yes') }}</BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
const emit = defineEmits(['noClick', 'yesClick']);

const handleExit = () => {
  emit('yesClick');
};
</script>
